import type {
    SchoolLogsControllerSearchSchoolsQueryParams
} from '@/global/api/gen/ts/school-logsDTO/SchoolLogsControllerSearchSchools';

export const SchoolLogsKeys = {
    all: ['school-logs'] as const,
    schoolLogs: (schoolId: number) => [SchoolLogsKeys.all, `${schoolId}`] as const,
    searchSchoolLogs: (params: SchoolLogsControllerSearchSchoolsQueryParams, schoolId: number) => [...SchoolLogsKeys.schoolLogs(schoolId), params] as const,
};